import type { SVGProps } from 'react';
const SvgTextRotateVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#text_rotate_vertical_svg__a)">
      <path
        fill="currentColor"
        d="M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5Zm-2.62 7L15 6.98 16.87 12h-3.74ZM6 19.75l3-3H7V4.25H5v12.5H3l3 3Z"
      />
    </g>
    <defs>
      <clipPath id="text_rotate_vertical_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTextRotateVertical;
